export enum JobStatusNewType {
  OPEN,
  ACTIVE,
  CLOSED,
  CANCELLED
}

export const JobStatusNewLabelType = {
  [JobStatusNewType.OPEN]: 'Open',
  [JobStatusNewType.ACTIVE]: 'Active',
  [JobStatusNewType.CLOSED]: 'Closed',
  [JobStatusNewType.CANCELLED]: 'Cancelled'
}

export enum JobStatusFilterLabels {
  OPEN = 'Scheduled',
  ACTIVE = 'In Progress',
  CLOSED = 'Completed',
  CANCELLED = 'Cancelled'
}
